import { CardShell, UploadDropzone } from '@atlas/ui-components'

/**
 * Collects files for classification WITHOUT starting an upload.
 *
 * The shared {@link UploadDropzone} handles the interaction; what is specific
 * here is that nothing is enqueued. Files staged on this page have not been sent
 * anywhere, so putting them in the global upload store would make the status-bar
 * chip claim uploads are running and warn the user about leaving a page with
 * nothing to lose. They reach the store only when Commit enqueues them, tuples
 * in hand.
 */
export interface StagingDropzoneProps {
	onFilesStaged: (files: File[]) => void
	/** Disabled while a commit is uploading, so the set can't shift mid-flight. */
	isDisabled?: boolean
}

export function StagingDropzone({ onFilesStaged, isDisabled = false }: StagingDropzoneProps) {
	return (
		<CardShell as="section" className="p-ds-4">
			<UploadDropzone
				// The accessible name stays task-specific; the visible prompt is the
				// generic drag-or-click line every surface shows.
				label="Add files to classify"
				prompt="Drag and drop files here, or click to browse"
				onFiles={onFilesStaged}
				isDisabled={isDisabled}
				inputTestId="staging-dropzone-input"
				// Set expectations up front: dropping here is not an upload.
				hint="Files are classified first — nothing is uploaded until you commit."
			/>
		</CardShell>
	)
}
